import React, { useState } from 'react';
import { Box, Flex, Text } from 'rebass';
import { graphql } from "gatsby";
import Image from "../image";
import { pathOr } from "ramda";
import BorderWrapper from "../borderWrapper";
import Video from "../video";
import Slider from "react-slick";
import ArrowIcon from '../../images/icons/arrow.svg';
import { CONTAINER_WIDTH } from "../../utils/constants";
import theme from "../../gatsby-plugin-theme-ui";

const Button = ({ children, sx = {}, ...props }) => (
	<Box
		{...props}
		as="button"
		height={[40, null, 50]}
		width={[40, null, 50]}
		sx={{
			...sx,
			position: 'absolute', right: 0,top: '50%', transform: 'translateY(-50%)', bg: 'background', zIndex: 1,
			svg: { path: { fill: 'text' } }
		}}
	>
		{children}
	</Box>
);

function SampleNextArrow(props) {
	const { onClick } = props;
	return (
		<Button
			onClick={onClick}
			sx={{ right: 0, svg: { path: { fill: 'text' } } }}
		>
			<ArrowIcon />
		</Button>
	);
}

function SamplePrevArrow(props) {
	const { onClick } = props;
	return (
		<Button
		 	onClick={onClick}
			sx={{ left: 0 }}
		>
			<ArrowIcon style={{ transform: 'rotate(180deg)' }}/>
		</Button>
	);
}

const ModuleCarousel = ({ module, active, ...props }) => {
	const items = pathOr([], ['relationships', 'items'], module);
	const [activeSlide, setActiveSlide] = useState(0);

	const sliderSettings = {
		dots: false,
		infinite: false,
		arrows: true,
		speed: 500,
		nextArrow: <SampleNextArrow />,
		prevArrow: <SamplePrevArrow />,
		beforeChange: (_, next) => setActiveSlide(next),
	};
	return (
		<BorderWrapper {...(props.bg ? { bg: props.bg } : {})}>
			<Flex alignItems="center" justifyContent="center" height={[null, null, "100%"]} width="100%" bg="bg" pb={[5, null, 0]} {...props}>
				<Box
					maxWidth={[null, null, CONTAINER_WIDTH]}
					maxHeight={[CONTAINER_WIDTH * 9 / 16]}
					height={[null, null, "100%"]}
					width={[`calc(100vw - ${theme.space[2] * 2}px)`, null, '100%']}
					sx={{
						position: 'relative',
						'.slick-track': {
							display: ['flex', null, 'block'],
							// background: theme.colors.blackest,
						},
						'.slick-track .slick-slide': {
							display: ['flex', null, 'block'],
							height: ['auto', null, '100%'],
							alignItems: 'center',
						},
						'.slick-track .slick-slide > div': {
							width: '100%',
						},
						'.slick-slider': {
							width: [null, null, '100%'],
							height: [null, null, '100%']
						},
						'.slick-track, .slick-list, .slick-slide > div': {
							height: [null, null, '100%']
						}
					}}
				>
					<Slider {...sliderSettings}>
						{items.map((item, i) => {
							const { type } = item.internal;
							switch (type) {
								case 'media__image':
									return (
										<Image
											imgStyle={{ objectFit: 'contain' }}
											objectFit="contain"
											key={item.id}
											width="100%"
											height={[null, null, "100%"]}
											fluid={pathOr({}, ['relationships', 'image', 'localFile', 'childImageSharp', 'fluid'], item)}
										/>
									);
								case 'media__video':
									return (
										<Video
											sx={{ video: { objectFit: 'contain' } }}
											key={item.id}
											width="100%"
											active={(i === activeSlide) && active}
											height={[null, null, "100%"]}
											autoplay
											playsinline
											src={pathOr('', ['relationships', 'video', 'localFile', 'publicURL'], item)}
										/>
									);
								default:
									return <Text>Media type is not supported</Text>
							}
						})}
					</Slider>
				</Box>
			</Flex>
		</BorderWrapper>
	)
};

export default ModuleCarousel;

export const query = graphql`
    fragment moduleCarouselFragment on paragraph__module_caroussel {
        internal {
            type
        }
        relationships {
            items: field_media_files {
                ... on media__image {
                    name
										id
                    relationships {
                        image: field_media_image {
                            localFile {
                                childImageSharp {
                                    fluid(maxWidth: 1400, quality: 80) {
                                        ...GatsbyImageSharpFluid_withWebp
                                    }
                                }
                            }
                        }
                    }
                    internal {
                        type
                    }
                }
                ... on media__video {
                    id
                    name
                    relationships {
                        video: field_media_video_file {
                            localFile {
                                publicURL
                            }
                        }
                    }
                    internal {
                        type
                    }
                }
            }
        }
    }
`;
